import { ReactComponent as ArrowDown } from '../../icons/arrow-down.svg';
import { ReactComponent as ArrowUp } from '../../icons/arrow-up.svg';
import {
    FinancialDisplaySearchFilter,
    QueryOrder,
} from '@boersenzeitung/shared/api.types';
import { classNames } from '@utils/classNames';
import { createKeyboardHandler } from '@utils/keyboard-handlers';
import React from 'react';

const ASC = '(aufsteigend)';
const DESC = '(absteigend)';

export const FinancialDisplayTableHeader = ({
    tableCellStyle,
    handleSortChange,
    filter,
}: {
    tableCellStyle: string;
    handleSortChange: (sortKey: string) => void;
    filter: FinancialDisplaySearchFilter;
}) => {
    const getSortArrow = (sortDirection?: QueryOrder) => {
        switch (sortDirection) {
            case QueryOrder.ASC:
                return <ArrowUp className="h-4 w-4 ml-2" aria-hidden="true" />;
            case QueryOrder.DESC:
                return (
                    <ArrowDown className="h-4 w-4 ml-2" aria-hidden="true" />
                );
            default:
                return null;
        }
    };

    return (
        <thead>
            <tr className="text-left font-bold bg-tablegray">
                <th className={tableCellStyle}>
                    <button
                        onClick={() => handleSortChange('appearanceDay')}
                        onKeyDown={createKeyboardHandler(() =>
                            handleSortChange('appearanceDay'),
                        )}
                        data-testid="appearanceDay-header-button"
                        aria-label={classNames(
                            'Nach Datum sortieren',
                            filter.sort?.keywords
                                ? filter.sort.keywords === QueryOrder.ASC
                                    ? ASC
                                    : DESC
                                : '',
                        )}
                    >
                        <div className="flex items-center">
                            <p className="hover:underline">Datum</p>
                            {getSortArrow(filter.sort?.appearanceDay)}
                        </div>
                    </button>
                </th>
                <th className={tableCellStyle}>
                    <button
                        onClick={() => handleSortChange('issuers')}
                        onKeyDown={createKeyboardHandler(() =>
                            handleSortChange('issuers'),
                        )}
                        data-testid="issuers-header-button"
                        aria-label={classNames(
                            'Nach Unternehmen sortieren',
                            filter.sort?.keywords
                                ? filter.sort.keywords === QueryOrder.ASC
                                    ? ASC
                                    : DESC
                                : '',
                        )}
                    >
                        <div className="flex items-center">
                            <p className="hover:underline">Unternehmen</p>
                            {getSortArrow(filter.sort?.issuers)}
                        </div>
                    </button>
                </th>
                <th className={tableCellStyle}>
                    <button
                        onClick={() => handleSortChange('keywords')}
                        onKeyDown={createKeyboardHandler(() =>
                            handleSortChange('keywords'),
                        )}
                        data-testid="keywords-header-button"
                        aria-label={classNames(
                            'Nach Schlagwort sortieren',
                            filter.sort?.keywords
                                ? filter.sort.keywords === QueryOrder.ASC
                                    ? ASC
                                    : DESC
                                : '',
                        )}
                    >
                        <div className="flex items-center">
                            <p className="hover:underline">Schlagwort</p>
                            {getSortArrow(filter.sort?.keywords)}
                        </div>
                    </button>
                </th>
                <th className={tableCellStyle}>Wertpapier</th>
                <th className={tableCellStyle}>PDF</th>
            </tr>
        </thead>
    );
};
